/**
 * Estilo común de los botones de página
 *
 * Fuente única de verdad para todos los features. Los botones fijan `height` en
 * vez de `py`: con `py` la altura depende de si el botón lleva icono, del
 * tamaño del icono y de la fuente, y dos botones "iguales" acababan midiendo
 * distinto en pantallas vecinas.
 *
 * Dos alturas, según dónde viva el botón:
 * - ALTURA_BOTON.CABECERA (40): acción principal de la cabecera de la página
 *   ("Nueva petición", "Añadir rango") y barras de herramientas.
 * - ALTURA_BOTON.FILTRO (56): botones dentro de una fila de filtros, a la misma
 *   altura que los TextField/Select a su lado.
 *
 * Uso:
 *   <Button variant="contained" sx={BOTON_PRIMARIO_SX}>Nueva petición</Button>
 *   <Button variant="outlined" sx={BOTON_SECUNDARIO_SX}>Limpiar</Button>
 *   <Button variant="contained" sx={{ ...BOTON_PRIMARIO_SX, height: ALTURA_BOTON.FILTRO }}>Buscar</Button>
 *
 * Los botones de los modales no entran aquí: siguen el "Patrón de Modales
 * Responsive" de CLAUDE.md.
 */

export const ALTURA_BOTON = {
    CABECERA: 40,
    FILTRO: 56,
};

const BOTON_BASE_SX = {
    height: ALTURA_BOTON.CABECERA,
    px: 3,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 15,
    whiteSpace: "nowrap",
};

/** Botón principal (contained, rojo corporativo) */
export const BOTON_PRIMARIO_SX = {
    ...BOTON_BASE_SX,
    backgroundColor: "#cc071e",
    color: "#fff",
    "&:hover": { backgroundColor: "#a30618" },
    "&:disabled": { backgroundColor: "#6c757d", color: "#fff" },
};

/** Botón secundario (outlined, gris) */
export const BOTON_SECUNDARIO_SX = {
    ...BOTON_BASE_SX,
    color: "#6c757d",
    borderColor: "#6c757d",
    "&:hover": { borderColor: "#495057", backgroundColor: "rgba(0,0,0,0.04)" },
};
